// extracted by mini-css-extract-plugin
module.exports = {"Container":"Notification_Container__1cmP6","Text":"Notification_Text__1m23H"};